import { companyFilterLabels } from '~/utils/companyFilters';
import convertFilterLabel from '~/utils/convertFilterLabel';

import { getSubDomain } from '~/utils/urlUtils';
import { DEFAULT_DOMAIN } from '~/services/SchoolService';

import i18n from '~/i18n';

const normalizeTitle = title =>
    ['HQ', 'Mother', 'International', ','].forEach(it => (title = title.replace(it, ''))) ||
    (title = title.replace(/\s+/, ' ').trim()) ||
    title;

export default {
    baseURL: process.env.VUE_APP_API_URL.concat('v1/'),
    staticQuery: _ => ({
        sub_domain: getSubDomain() || DEFAULT_DOMAIN,
    }),
    // baseURL: 'http://127.0.0.1:8080/api/v1/',
    // entry: data => data.data.companies || [],
    template: [
        'company_template',
        data => {
            // const locationInfo =
            //     ((data.derivedInfo || {}).headquartersLocation || {})
            //         .postalAddress || {};
            return {
                id: data.id, // parseId(data.name),
                name: normalizeTitle(data.title), // data.displayName,
                externalId: data.id, // data.externalId,
                logo: data.logo, // data.imageUri,
                link: data.webAddress || '', // data.websiteUri,
                description: data.description || '', // (data.data || {}).description || '',

                labels: IS_PROD
                    ? []
                    : Math.random() < 0.3
                    ? [
                          {
                              type: 'img',
                              text: i18n.t('gptw.company.alt'),
                              tooltip: i18n.t('gptw.company.tooltip'),
                              img:
                                  'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcR8bNFI1aiRnfl9fsyywxu1R_D1heD7RsMZ1MDqzA-ATpX-N2dK',
                          },
                      ]
                    : [],

                gptw: IS_PROD
                    ? null
                    : {
                          text: i18n.t('gptw.company.alt'),
                          tooltip: i18n.t('gptw.company.tooltip'),
                          img:
                              'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcR8bNFI1aiRnfl9fsyywxu1R_D1heD7RsMZ1MDqzA-ATpX-N2dK',
                      },
            };
        },
        {
            // pageInfo: res => ({
            //     next: res.data.nextPageToken,
            //     length: (res.data.companies || []).length,
            // }),
            nextPageQuery: prev => {
                return false;
                // if (!prev.next) {
                //     return false;
                // }
                // return { page_token: prev.next };
            },
        },
    ],

    GET: {
        authorize: true,
    },

    '/:id': {
        GET: 'get_best_company',
        entry: data => data.data,
    },

    '/filters': {
        template: [
            'FILTER_TEMPLATE',
            data => {
                const filters = Object.keys(data).map(key => ({
                    label: companyFilterLabels[key],
                    value: key,
                    options: data[key]
                        .filter(e => e)
                        .map(e => ({ value: e, label: convertFilterLabel(e) })),
                }));

                return { id: 1, filters };
            },
        ],
        GET: 'filters',
    },
};
